"use client";
import React from 'react';

/**
 * React hook to manage boolean (on - off) states
 *
 * @param initialState the initial boolean state value
 * @example
 * ```javascript
 * const [visible, setVisible] = useBoolean(false)
 * ```
 */
function useBoolean(initialState = false) {
    const [value, setValue] = React.useState(initialState);
    const on = React.useCallback(() => {
        setValue(true);
    }, []);
    const off = React.useCallback(() => {
        setValue(false);
    }, []);
    const toggle = React.useCallback(() => {
        setValue((prev) => !prev);
    }, []);
    return React.useMemo(() => [value, { on, off, toggle }], [off, on, toggle, value]);
}

export { useBoolean };
//# sourceMappingURL=useBoolean.js.map
